<template>
  <d-modal
    v-if="showModal"
    class="crm-new-popup sms-modal"
    style="background-color: rgba(0,0,0,0.6)!important;">
    <d-modal-header>
      <d-modal-title>
        <h3 class="page-title sms-title">
          <template>Wyślij SMS z linkiem do formularza</template>
        </h3>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <validation-observer
        ref="customers-form-institutions"
        tag="form">
        <div class="form-group">
          <d-input-group class="mb-2">
            <d-input
              id="copyAndSend"
              placeholder="Email Address"
              v-model="dataUrl"/>
            <d-input-group-addon append>
              <d-button
                outline
                @click.stop.prevent="copyCode"
                theme="primary">
                <i class="material-icons">content_copy</i>
                Kopiuj adres URL
              </d-button>
            </d-input-group-addon>
          </d-input-group>
        </div>
        <div class="popup-box-buttons">
          <d-button
            theme="danger"
            @click.prevent="sendAMessage"
            class="text-nowrap">
            <i class="material-icons">send_to_mobile</i>
            Wyślij SMS
          </d-button>
          <d-button
            theme="secondary"
            class="text-nowrap ml-3"
            @click.prevent="closeModal">
            Wyjdź
          </d-button>
        </div>
      </validation-observer>
    </d-modal-body>
  </d-modal>
</template>

<script>
import Vue from 'vue';
import ListUtils from '../../utils/ListUtils.js';

export default {
  name: 'customer-send-form',
  data () {
    return {
      dataUrl: ''
    };
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    closeModal: {
      type: Function,
      required: true
    },
    refreshList: {
      type: Function
    },
    customerId: {
      type: [String, Number],
      required: true
    },
    customerUrl: {
      type: String,
      required: true
    },
  },
  watch: {
    'customerUrl': function (value) {
      if (value) {
        this.dataUrl = JSON.parse(JSON.stringify(value));
      }
    },
    'dataUrl': function (value) {
      if (value) {
        this.dataUrl = this.customerUrl;
      }
    }
  },
  methods: {
    copyCode () {
      let testingCodeToCopy = document.querySelector('#copyAndSend');
      testingCodeToCopy.setAttribute('type', 'text');
      testingCodeToCopy.select();

      try {
        const successful = document.execCommand('copy');
        const msg = successful ? 'Skopiowano link' : 'Nie udało się skopiować linku';
        Vue.swal(msg);
      } catch (err) {
        Vue.swal('Ups, nie można skopiować');
      }
      window.getSelection();
    },
    sendAMessage () {
      this.remove_in_progress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/customers/send-sms-with-order-url/',
        id: this.customerId,
        successTitle: 'Wysłano',
        successText: 'Wiadomość SMS została wysłana do klienta',
        confirmTitle: 'Czy na pewno chcesz wysłać wiadomość SMS z linkiem do formularza?',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Wysyłanie SMS-a nie powiodło się. Spróbuj ponownie.',
        buttonOkText: 'Wyślij',
        successAction: () => {
          this.closeModal();
        },
        cancelAction: () => {
          this.remove_in_progress = false;
        }
      });
    }
  }
};
</script>

<style lang="scss">
  .sms-modal {
    .modal-dialog {
      margin-top: 30vh !important;
    }
    .sms-title {
      font-size: 30px !important;
    }
  }

</style>
